import React from 'react'
import ModalTitle from './ModalTitle'

type TProps = {
  title: string
  /** A secondary line under the title, inside the header */
  subtitle?: React.ReactNode
}

const ModalHeader = ({ title = '', subtitle }: TProps) => (
  <header className="Modal_Header">
    <ModalTitle>{title}</ModalTitle>
    {subtitle && <p className="Modal_Subtitle">{subtitle}</p>}
  </header>
)

export default ModalHeader
